import axios from 'axios';

export default {
    async store(customer, customerFile, onUploadProgress = null) {
        let formData = new FormData;
        for (let key in customerFile)
            formData.append(key, customerFile[key]);
        let response = await axios.post(`/api/customers/${customer.id}/files`, formData, { onUploadProgress });
        return response.data;
    },
    async update(customerFile) {
        let response = await axios.patch(`/api/customers/files/${customerFile.id}`, customerFile);
        return response.data;
    },
    async delete(customerFile) {
        let response = await axios.delete(`/api/customers/files/${customerFile.id}`);
        return response.data;
    },
};
